import { MutableRefObject, useEffect } from 'react';
import useObjectVisibility from '@hooks/useObjectVisibility';

const useTabVisibility = (elementRef: MutableRefObject<Element | null>) => {
  const isVisible = useObjectVisibility(elementRef, 0.1, false);

  useEffect(() => {
    if (isVisible) {
      elementRef.current?.setAttribute('tabindex', '0');
    } else {
      elementRef.current?.setAttribute('tabindex', '-1');
    }
  }, [isVisible, elementRef]);
};

export default useTabVisibility;
